import React from 'react';
import { ReferenceInput, ReferenceArrayInput, useLocale } from 'react-admin';

import { translateApiProperty } from '@hisports/common';

import AutocompleteInput from '../../common/inputs/AutocompleteInput';
import AutocompleteSuggestion from '../../common/inputs/AutocompleteSuggestion'

import { ParticipantIcon } from '../icons'

const filterExtraParticipants = name => ({ name })

const ParticipantExtraSuggestion = ({ suggestion: member, query, isHighlighted, ...props }) => {
  const locale = useLocale();

  let secondary = member?.participant?.HCRId

  if (member?.team) {
    secondary = `${secondary ? `${secondary} - ` : ''}${member?.team?.name} (${translateApiProperty(member?.team?.category, 'name', locale)})`
  }

  return <AutocompleteSuggestion icon={<ParticipantIcon />} primary={member?.participant?.fullName} secondary={secondary} />
}

export const ParticipantExtraInput = ({ allowEmpty, helperText, multiple, ...props }) => {
  const Input = multiple ? ReferenceArrayInput : ReferenceInput;

  return <Input
    reference="members"
    target="participants"
    filterToQuery={filterExtraParticipants}
    sort={{
      field: 'participant.lastName',
      order: 'ASC'
    }}
    perPage={25}
    {...props}
  >
    <AutocompleteInput
      optionText="participant.fullName"
      suggestionComponent={ParticipantExtraSuggestion}
      filterKeys={['participant.lastName', 'participant.firstName', 'participant.fullName', 'participant.HCRId']}
      multiple={multiple}
      helperText={helperText}
      emptyOptionsText="resources.participants.messages.search_by_name"
      resettable
      allowEmpty
    />
  </Input>
}
